import { ENV } from "@/lib/env";

const IMAGES = [
  { src: ENV.STORY_IMG_1, label: "Thailand · $900" },
  { src: ENV.STORY_IMG_2, label: "Bali · building" },
  { src: ENV.STORY_IMG_3, label: "Dubai · $25k/mo" },
];

const PARAS = [
  "I'm not Iman Gadzhi. I'm not Cole Gordon. I'm not somebody who's been in this game for 10 years.",
  "A few years ago I was a 14-year-old kid who dropped out of school with no plan, no money, and no idea what I was going to do.",
  "For the first six months I played Fortnite all day in my bedroom. My parents wanted me back in school. I didn't have an answer. I just knew the system wasn't for me.",
  "The first business failed. I'll save the details. It crashed hard enough that I deleted social media, shaved my head, and didn't work for five months.",
  "I came back at 16. Tried copywriting. Quit. Tried another agency model. Quit. By December I was about to give up for real.",
  "Then I got a DM from a closer. He booked me on a call. I got closed for $1,300 I didn't have. I borrowed it from neighbours and my parents to pay the rest. That was the only investment that ever actually worked.",
  "For two months after I locked into that mentorship, I didn't get an offer. I was 16, living in the UK, in a dark room, applying for jobs while my mum tried to push me back into college. There were days I didn't sleep. There were days I doubted everything.",
  "I got my first offer months later. $500 the first month. $2k by the third. $9k a month by summer.",
  "Six months ago, my mentor and I flew to Thailand with $900 between us. There were weeks we couldn't afford noodles. We borrowed money. We worked through it.",
  "I'm 18 now. I'm in Dubai writing this. Last month I cleared $25k. The month before, $18k. I close on a high-ticket offer on a sales floor I helped build.",
  "I built Closer Academy because the thing that actually changed my life was not the content. It was being inside a room with a real mentor, real reps, and a real path at the same time.",
  "That's the whole product. The frame. The reps. The room. The door.",
];

export default function AlexStory() {
  return (
    <section id="story" className="access-section">
      <span className="gold-rule-v" aria-hidden />
      <div className="access-container">
        <div className="max-w-[720px] mx-auto">
          <span className="mono-label mono-label-gold">Why I built this</span>
          <h2 className="h-section mt-6">
            I dropped out at 14. I almost gave up at 16. I cleared <span>$100k</span> before I turned 18.
          </h2>

          <div className="mt-14 space-y-6">
            {PARAS.map((p, i) => (
              <p
                key={i}
                className={
                  i === 0
                    ? "drop-cap text-[1.0625rem] leading-[1.75] text-dim"
                    : i >= PARAS.length - 2
                    ? "font-display italic text-bone text-2xl leading-[1.3]"
                    : "text-[1.0625rem] leading-[1.75] text-dim"
                }
                style={i >= PARAS.length - 2 ? { fontVariationSettings: '"opsz" 96, "SOFT" 80', fontWeight: 350 } : undefined}
              >
                {p}
              </p>
            ))}
            <p className="font-display italic text-gold text-2xl leading-snug mt-10" style={{ fontVariationSettings: '"opsz" 96, "SOFT" 100', fontWeight: 350 }}>
              You don't need another playlist. You need to be in.
            </p>
          </div>

          {/* photography rail — only renders when assets exist */}
          {IMAGES.some((i) => i.src) && (
            <div className="mt-20 grid grid-cols-3 gap-3">
              {IMAGES.map((img, i) => (
                <figure key={i} className="surface-card overflow-hidden">
                  <div className="relative aspect-[4/5] bg-surface-elev">
                    {img.src ? (
                      <img src={img.src} alt={img.label} loading="lazy" className="absolute inset-0 w-full h-full object-cover" style={{ filter: "saturate(0.9) contrast(1.05)" }} />
                    ) : null}
                    <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, transparent 55%, rgba(0,0,0,0.7))" }} />
                  </div>
                  <figcaption className="px-3 py-2.5 font-mono text-[9.5px] tracking-[0.2em] uppercase text-gold border-t border-soft">{img.label}</figcaption>
                </figure>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
